import React, { Component } from 'react';
import DropDown2 from '../Report/Controls/DropDown2'
import { GetOption, GetOptions, SaveOption, encodeOpt } from '../database/Options';

const savedValues = ["building", "address"];
const display = [ "Building", "Address" ]

export default class LocationDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: display,
      shown: 0,
    }
    this.optionName = "locationDesc"
  }
  async componentDidMount() {
    const value = GetOption(await GetOptions (this.props), this.optionName)?.value
    this.setState ({shown: Math.max(0, savedValues.indexOf(value))})
  }
  onUpdate(toSave, props) {
    SaveOption(encodeOpt(this.optionName, toSave), props)
  }
  render () {
    return <DropDown2 {...this.state} {...this.props} value={display[this.state.shown]}
        onUpdate={(param)=>this.onUpdate (savedValues[param], this.props)}/>
  }
}
